import React from "react";
import { ProducerPreviewReportPeriodCellTemplate } from "themes/common/components/producer";

function ProducerPreviewReportPeriodCell(props) {
    return <ProducerPreviewReportPeriodCellTemplate {...props} />;
}

export default ProducerPreviewReportPeriodCell;
